import React, { useState } from 'react'

import { FaRegEdit, FaRegTrashAlt } from 'react-icons/fa'
import { WiTime9 } from 'react-icons/wi'

import colors from '../../../_constants/colors'
import { getShortMonthAndYearFromDate } from '../../../_helpers'

import { Box } from '../../../components/Box/Box'
import { Button } from '../../Button'
import { ButtonRow } from '../../layout/ButtonRow'
import { FormRow } from '../../Forms/FormRow'
import { RenderIf } from '../../../components/helpers/RenderIf/RenderIf'
import { Text } from '../../Typography/Components/Text/Text'

import { S_TimeLineNote } from './TimeLineNote.styles'

export const TimeLineNote = ({ note = {}, onRemove = () => {}, onUpdate = () => {} }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [localNote, setLocalNote] = useState(note)
  const [noteChanged, setNoteChanged] = useState(note && note.content !== localNote.content)
  const [deleteWarning, showDeleteWarning] = useState(false)

  const handleNoteChange = (value) => {
    setLocalNote((prevNote) => ({ ...prevNote, content: value }))
    setNoteChanged(note?.content !== value)
  }

  const handleCancel = () => {
    setLocalNote(note)
    setIsEditing(false)
    setNoteChanged(false)
  }

  const handleUpdate = () => {
    onUpdate(localNote)
    setIsEditing(false)
  }

  return (
    <S_TimeLineNote>
      <div className={'note-date'}>
        <Text fs={'14px'} minWidth={'90px'} textColor={colors.LIGHT_GREY}>
          {getShortMonthAndYearFromDate(note?.created_at, true)}
        </Text>
        <div className={'date-timeline-icon'}>
          <WiTime9 color={colors.FINVOICE_BLUE} />
        </div>
      </div>
      <Box className={'note-container'}>
        <Box
          alignItems={'center'}
          borderRadius={'3px'}
          boxBackgroundColor={colors.INNER_GREY_BOX}
          className={'note-top-bar'}
          d={'flex'}
          justifyContent={'space-between'}
          mb={'10px'}
          pb={'2px'}
          pl={'15px'}
          pr={'10px'}
          pt={'2px'}
        >
          <Text className={colors.DEFAULT_TEXT} fs={'14px'}>
            {note.created_by}
          </Text>
          <Box>
            <Button
              className={'icon compact'}
              disabled={isEditing && noteChanged}
              onClick={() => {
                setIsEditing((prev) => !prev)
              }}
            >
              <FaRegEdit size={'16px'} />
            </Button>
            <Button className={'icon compact hover-destroy'} onClick={() => showDeleteWarning(true)}>
              <FaRegTrashAlt size={'14px'} />
            </Button>
          </Box>
        </Box>

        <RenderIf condition={deleteWarning}>
          <Box borderRadius={'3px'} boxBackgroundColor={colors.DEFAULT_TEXT} mb={'10px'} p={'15px'}>
            <Text align={'center'} mb={'10px'} textColor={colors.WHITE}>
              Delete This Note?
            </Text>
            <ButtonRow align={'center'}>
              <Button className={'compact secondary-white'} onClick={onRemove}>
                Yes
              </Button>
              <Button className={'compact secondary-white no-border'} onClick={() => showDeleteWarning(false)}>
                Cancel
              </Button>
            </ButtonRow>
            <Text align={'center'} fs={'12px'} mt={'10px'} textColor={colors.WHITE}>
              Caution: This cannot be undone
            </Text>
          </Box>
        </RenderIf>

        <div className={'note-body'}>
          <div className="note-content">
            {isEditing ? (
              <>
                <FormRow
                  autoFocus
                  defaultValue={localNote?.content || ''}
                  label=""
                  onChange={handleNoteChange}
                  type="textarea"
                />
                <ButtonRow align="right">
                  <Button className="compact secondary" onClick={handleCancel} text="Cancel" />
                  <Button className="compact primary" disabled={!noteChanged} onClick={handleUpdate} text="Save" />
                </ButtonRow>
              </>
            ) : (
              <Box
                borderColor={colors.OUTLINE_GREY_BOX}
                borderRadius={'3px'}
                borderWidth={'1px'}
                pb={'9px'}
                pl={'12px'}
                pr={'12px'}
                pt={'9px'}
              >
                <Text fs={'14px'}>{note.content}</Text>
              </Box>
            )}
          </div>
        </div>
      </Box>
    </S_TimeLineNote>
  )
}
